import { render, staticRenderFns } from "./CardTotalDistance.vue?vue&type=template&id=66cbfbdc&scoped=true&"
import script from "./CardTotalDistance.vue?vue&type=script&lang=js&"
export * from "./CardTotalDistance.vue?vue&type=script&lang=js&"
import style0 from "./CardTotalDistance.vue?vue&type=style&index=0&id=66cbfbdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cbfbdc",
  null
  
)

export default component.exports